// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  cancelledByStaff: (t, data?, options?) => t('enum.teacher-change-reason.cancelled-by-staff.name', data, options),
  cancelledByTeacher: (t, data?, options?) => t('enum.teacher-change-reason.cancelled-by-teacher.name', data, options),
  teacherAbsent: (t, data?, options?) => t('enum.teacher-change-reason.teacher-absent.name', data, options),
  /* eslint-enable max-len */
};
